import { useEffect, useState } from 'react';
import { clienteApi } from '../../common/axios';

function euro(v) {
  return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(v || 0);
}

export default function WalletPanel() {
  const [riepilogo, setRiepilogo] = useState(null);
  const [movimenti, setMovimenti] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      clienteApi.get('/cliente/wallet'),
      clienteApi.get('/cliente/wallet/movimenti'),
    ])
      .then(([rRes, mRes]) => {
        setRiepilogo(rRes.data.riepilogo);
        setMovimenti(mRes.data.data?.data || []);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-4 text-center">Caricamento wallet...</div>;
  if (!riepilogo) return <div className="p-4 text-center">Impossibile caricare il wallet</div>;

  return (
    <div className="space-y-6">
      <div className="mang-card p-6 bg-gradient-to-br from-[#c78244] to-[#a66a35] text-white">
        <h2 className="text-lg opacity-90 mb-2">Saldo Disponibile</h2>
        <div className="text-4xl font-bold mb-4">{euro(riepilogo.saldo_credito)}</div>
        <p className="text-sm opacity-80">
          Il tuo credito verrà scalato automaticamente al completamento del prossimo ordine.
        </p>
        {riepilogo.tipo_account === 'closer' && (
          <div className="mt-4 pt-4 border-t border-white/20 flex items-center justify-between">
            <span className="text-sm font-medium px-3 py-1 bg-white/20 rounded-full">
              Account Closer Attivo
            </span>
            {riepilogo.prelievi_in_attesa > 0 && (
              <span className="text-sm">In attesa prelievo: {euro(riepilogo.prelievi_in_attesa)}</span>
            )}
          </div>
        )}
      </div>

      <div className="mang-card p-6">
        <h3 className="font-bold mb-4">Ultimi Movimenti</h3>
        {movimenti.length === 0 ? (
          <p className="text-gray-500 text-sm">Nessun movimento registrato.</p>
        ) : (
          <div className="space-y-3">
            {movimenti.map((m) => (
              <div key={m.id} className="flex justify-between items-center py-2 border-b last:border-0">
                <div>
                  <p className="font-medium text-sm">{m.descrizione || m.tipo.replace(/_/g, ' ')}</p>
                  <p className="text-xs text-gray-400">
                    {new Date(m.created_at).toLocaleDateString('it-IT')}
                    {m.ordine_id && ` • Ordine #${m.ordine?.numero_ordine || m.ordine_id}`}
                  </p>
                </div>
                <div className={`font-bold ${m.importo > 0 ? 'text-green-600' : 'text-gray-900'}`}>
                  {m.importo > 0 ? '+' : ''}{euro(m.importo)}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
